var $64cb6a9be1f6fa48$exports = {};
$64cb6a9be1f6fa48$exports = {
  "calendar": `\u{5DC}\u{5D5}\u{5D7} \u{5E9}\u{5E0}\u{5D4}`,
  "day": `\u{5D9}\u{5D5}\u{5DD}`,
  "dayPeriod": `\u{5DC}\u{5E4}\u{5E0}\u{5D4}\u{5F4}\u{5E6}/\u{5D0}\u{5D7}\u{5D4}\u{5F4}\u{5E6}`,
  "endDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
  "era": `\u{5EA}\u{5E7}\u{5D5}\u{5E4}\u{5D4}`,
  "hour": `\u{5E9}\u{5E2}\u{5D4}`,
  "minute": `\u{5D3}\u{5E7}\u{5D4}`,
  "month": `\u{5D7}\u{5D5}\u{5D3}\u{5E9}`,
  "second": `\u{5E9}\u{5E0}\u{5D9}\u{5D9}\u{5D4}`,
  "selectedDateDescription": args => `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.date}`,
  "selectedRangeDescription": args => `\u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.startDate} \u{5E2}\u{5D3} ${args.endDate}`,
  "selectedTimeDescription": args => `\u{5D6}\u{5DE}\u{5DF} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.time}`,
  "startDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
  "timeZoneName": `\u{5D0}\u{5D6}\u{5D5}\u{5E8} \u{5D6}\u{5DE}\u{5DF}`,
  "weekday": `\u{5D9}\u{5D5}\u{5DD} \u{5D1}\u{5E9}\u{5D1}\u{5D5}\u{5E2}`,
  "year": `\u{5E9}\u{5E0}\u{5D4}`
};
export { $64cb6a9be1f6fa48$exports as default };